import { render, staticRenderFns } from "./kindChooseView.vue?vue&type=template&id=100fb01a&scoped=true"
import script from "./kindChooseView.vue?vue&type=script&lang=js"
export * from "./kindChooseView.vue?vue&type=script&lang=js"
import style0 from "./kindChooseView.vue?vue&type=style&index=0&id=100fb01a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100fb01a",
  null
  
)

export default component.exports